export default __webpack_public_path__ + "static/media/male.5b900ecd.svg";